// https://bugzilla.mozilla.org/show_bug.cgi?id=1355389
// https://bugzilla.mozilla.org/show_bug.cgi?id=1456557
// https://caniuse.com/#feat=input-file-multiple
const MozillaAndroidDoesNotSupportMultiFileSelect =
  navigator.userAgent.includes('Gecko/') && navigator.userAgent.includes('Android');

export default MozillaAndroidDoesNotSupportMultiFileSelect;
